import * as React from 'react';
import { withStyles } from '@material-ui/core/styles';
import style from './Nodes.style';
import {
    FMTreeNode,
    FMTreeGroupNodeWithStore,
} from 'atoms';
import { ItemProps } from '../../organisms/FMTree/TypesForNodes';

class FMTreeRootEmptyNode extends React.Component<ItemProps> {

    public render() {
        return (
            <FMTreeNode
                level={this.props.level}
                selected={this.props.selected}
                selectNode={this.props.selectNode}
            >
                <div />
            </FMTreeNode>
        );
    }

}

export default withStyles(style)(FMTreeGroupNodeWithStore(FMTreeRootEmptyNode));
